import React from 'react'
import Pricing from './pricing'

export default function About() {
  return (
    <>
        <div className='About-BG'>
            <div className='About-content'>
                <div className='text'>
                <h1>ABOUT US</h1><br />
                <p>This is a business built on people.
                Yes, we want to be known for our ideas, our technological innovations, our exceptional products.
                But none of it is achievable without talented individuals working
                together to make a diverse and successful team</p>

                <hr />

                <p>Our challenge goes beyond making great cars we have to reimagine the future. You can see that as daunting, but to us it's a wonderful opportunity, the start of an extraordinary journey for our business, our customers, and for you…</p>

                <hr />

                <p>Bentley is a relatively small company with its own unique brand and culture, but we are also part of one of the world's biggest automotive businesses with all the exciting opportunities and benefits that brings.
                    <br />

                When you begin your career journey with us you immediately become part of Bentley's 4,000-strong team based in Crewe, sharing in the culture and values that are unique to our business. 
                <br />

                But Bentley is not a small player in the global marketplace, it is one of the 12 automotive brands which make up VW Group. The world's leading car maker. Our sister brands include Porsche, Lamborghini, Bugatti, Audi, VW, Seat, Skoda and Ducati, as well as commercial vehicle brands Scania, MAN and VW. Together these businesses employ 650,000 people across 125 locations on five continents.</p>
                </div>


            </div>
        </div>
        <Pricing/>
    </>
  )
}
